import React, { useRef, useEffect } from "react";
import Chart, { ChartConfiguration } from "chart.js/auto";

interface DoughnutChartProps {
  height?: number;
  width?: number;
  labels: string[];
  backgroundColors: string[];
  hoverBackgroundColors: string[];
  data: number[];
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({
  height,
  width,
  labels,
  backgroundColors,
  hoverBackgroundColors,
  data
}) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstanceRef = useRef<Chart<"doughnut"> | null>(null);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");

      if (ctx) {
        // Destroy the existing chart if it exists
        if (chartInstanceRef.current) {
          chartInstanceRef.current.destroy();
        }

        // Create the new chart
        chartInstanceRef.current = new Chart(ctx, {
          type: "doughnut",
          data: {
            labels: labels,
            datasets: [
              {
                data,
                backgroundColor: backgroundColors,
                hoverBackgroundColor: hoverBackgroundColors
              }
            ]
          },
          options: {
            plugins: {
              legend: {
                position: "bottom" // Set legend position to bottom
              }
            }
          } // Add any chart options here
        } as ChartConfiguration<"doughnut">); // Type assertion
      }
    }

    // Cleanup function to destroy the chart when the component is unmounted or when the canvas changes
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [chartRef]);

  return <canvas ref={chartRef} height={200}></canvas>;
};

export default DoughnutChart;
